import { useState, useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";

export const useIsAdmin = () => {
  const { user, session } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAdminRole = async () => {
      if (!user || !session) {
        setIsAdmin(false);
        setIsLoading(false);
        return;
      }

      try {
        // Call server-side edge function to verify admin status
        const response = await supabase.functions.invoke('verify-admin', {
          headers: {
            Authorization: `Bearer ${session.access_token}`,
          },
        });

        if (response.error) {
          if (import.meta.env.DEV) {
            console.error("Error verifying admin status:", response.error);
          }
          setIsAdmin(false);
        } else {
          setIsAdmin(response.data?.isAdmin ?? false);
        }
      } catch (error) {
        if (import.meta.env.DEV) {
          console.error("Error checking admin role:", error);
        }
        setIsAdmin(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAdminRole();
  }, [user, session]);

  return { isAdmin, isLoading };
};
